interface HttpDataModel {
  url: string;
  other: any
}
export default {
  url: process.env.REACT_APP_URL_API,
  other: {}
} as HttpDataModel
